// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__zuw8r","boxTitle":"Qualiphy_boxTitle__qQRvC","box":"Qualiphy_box__2So3F","toggleWrap":"Qualiphy_toggleWrap__3m8uT"};